import {
    BuilderInterface,
    BuilderOptionInterface,
    Collection,
    EntityTimeInterface,
    FactoryInterface,
    TimeFormatInterface
} from "./Main";
import {TodoistSync} from "./TodoistSync";
import {TaskInterface} from "./Task";
import {ColorTypeSingleton, ColorTypeInterface} from "./Color";
import {CollectionHelper} from "./App";




export interface ProjectInterface extends EntityTimeInterface{

    getID(): number;

    getColor(): ColorTypeInterface;

    setColor(color: ColorTypeInterface):void;

    getName(): string;

    getPatentId(): number;

    addTask(task: TaskInterface):void;
    getTasks(): Collection<TaskInterface>;

    getTime(): TimeFormatInterface

}

abstract class ProjectAbstract implements ProjectInterface{


    protected tasks : Collection<TaskInterface>;
    protected color : ColorTypeInterface;
    constructor(private readonly project: TodoistSync.ProjectInterface ){
        this.tasks = new Collection();
    }

    getColor(): ColorTypeInterface {
        return this.color;
    }
    setColor(color: ColorTypeInterface): void {
        this.color = color;
    }


    getID(): number {
        return this.project.id;
    }

    getName(): string {
        return this.project.name;
    }

    getPatentId(): number {
        return this.project.parent_id;
    }

    addTask(task: TaskInterface): void {
        if(!this.tasks.isset(task)) {
            this.tasks.addItem(task)
        }
        if(task.getProject().getID() != this.getID()){
            task.setProject(this);
        }
    }

    getTasks(): Collection<TaskInterface> {
        return this.tasks;
    }

    getTime(): TimeFormatInterface {
        return CollectionHelper.sumTime(this.getTasks());

    }


}

export class Project extends ProjectAbstract{

}

interface ProjectBuilderOptionInterface extends BuilderOptionInterface{

    props: {
        projects: TodoistSync.ProjectInterface[]
    }
}

/***
 * @todo убрать передачу options в конструкторе
 */
export class ProjectBuilder implements BuilderInterface<TodoistSync.ProjectInterface, ProjectInterface> {

    private projectTypes: any = [];
    private colors: ColorTypeSingleton;
    constructor(private options?: ProjectBuilderOptionInterface ){

        // this.projectTypes[ColorFixture.Work] = ProjectWork;
        // this.projectTypes[ColorFixture.Person] = ProjectPerson;
        // this.projectTypes[ColorFixture.Freelance] = ProjectFreelance;
        // this.projectTypes[ColorFixture.SkillBuilding] = ProjectSkillBuilding;
        this.colors = ColorTypeSingleton.getInstance();
    }


    /**
     * Метод для создания типового проекта на основе типа родительского
     * @param project
     * @deprecated
     */
    private createByParentType(project: TodoistSync.ProjectInterface): ProjectInterface|null{
        let parentProjectIds = this.options.props.projects.filter((value, index, array) => {
            return project.parent_id == value.id;
        });
        let projectCreate: null|ProjectInterface;
        parentProjectIds.forEach((value)=> {
            if(this.projectTypes[value.color] !== undefined){
                projectCreate =  new this.projectTypes[value.color](project);
            }
        });
        return projectCreate;
    }

    build(project: TodoistSync.ProjectInterface) {

        // let createProject: ProjectInterface;
        //
        //
        // if(this.projectTypes[project.color] !== undefined){
        //     createProject = new this.projectTypes[project.color](project);
        // }else {
        //     createProject = this.createByParentType(project)||new Project(project);
        // }

        let createProject: ProjectInterface = new Project(project);
        createProject.setColor(this.colors.getById(project.color));
        return  createProject;


    }
}




